var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.filePath)?_c('img',{class:_vm.$style.credIcon,attrs:{"src":_vm.filePath}}):(_vm.relevantNode)?_c('NodeIcon',{attrs:{"nodeType":_vm.relevantNode,"size":28}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }